module.exports = __webpack_public_path__ + "img/cuidado-personal.f209cbcc.png";